import http from "../../backend/http.js";

async function uploadImage(formData) {
  const response = await http.post("/images", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data;
}

export { uploadImage };
